module.exports = __webpack_public_path__ + "static/media/T-C_RCP.953f41d9.pdf";